const apiServiceWithProgress = async ({
  uri,
  method = 'GET',
  type = 'FILE',
  data = null,
  headers = {},
  onProgress = () => {}, // 接收进度更新回调
}) => {
  const url = uri;
  const config = {
    method,
    headers: {
      ...headers,
    },
  };

  // 如果是 FormData 类型的请求体，直接使用，不需要 JSON.stringify
  if (data && !(data instanceof FormData) && !['GET', 'DELETE'].includes(method.toUpperCase())) {
    config.body = JSON.stringify(data);
    config.headers['Content-Type'] = 'application/json'; // 仅对非 FormData 请求设置 JSON 类型
  } else if (data instanceof FormData) {
    config.body = data; // 直接使用 FormData，不需要修改 headers
  }

  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('Content-Type') || '';

    if (method.toUpperCase() === 'GET' && type === 'FILE') {
      // 如果是文件下载，使用流式处理
      const reader = response.body.getReader();
      const contentLength = +response.headers.get('Content-Length');
      let receivedLength = 0;
      const chunks = [];

      // 递归读取数据块
      return reader.read().then(function processChunk({ done, value }) {
        if (done) {
          console.log('下载完成');
          // 合并所有块
          const data = new Uint8Array(receivedLength);
          let position = 0;
          for (const chunk of chunks) {
            data.set(chunk, position);
            position += chunk.length;
          }

          const blob = new Blob([data]);
          const objectURL = URL.createObjectURL(blob);

          // 下载文件链接
          const downloadLink = document.createElement('a');
          downloadLink.href = objectURL;

          const contentDisposition = response.headers.get('Content-Disposition');
          const filename = contentDisposition
            ? contentDisposition.split('filename=')[1].replace(/['"]/g, '')
            : 'downloaded_file.zip';

          downloadLink.download = filename;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);

          // 清理 URL 对象
          URL.revokeObjectURL(objectURL);

          return { response, objectURL };
        }

        // 将数据块添加到 chunks 中
        chunks.push(value);
        receivedLength += value.length;

        // 计算下载进度并调用回调更新
        const percentage = ((receivedLength / Number(contentLength)) * 100).toFixed(0); // 保留0位小数
        // 检查 onProgress 是否是一个函数，如果是则调用
        if (typeof onProgress === 'function') {
          onProgress(percentage); // 调用回调更新进度
        }

        // 继续读取下一个数据块
        return reader.read().then(processChunk);
      });
    }

    // 处理非文件类型返回值（JSON、文本等）
    if (contentType.includes('application/json')) {
      return await response.json();
    } else if (contentType.includes('text/')) {
      return await response.text();
    } else {
      return response;
    }
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

export default apiServiceWithProgress;
